import React, { useState } from 'react'
import ListItemText from '@mui/material/ListItemText'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { grey } from '@mui/material/colors'

import ListItemIcon from 'components/Sidebar/Styled/ListItemIcon'
import ListItemButton from 'components/Sidebar/Styled/Button'

type HelpProps = {
  hasIconOnly?: boolean
}

const Help = ({ hasIconOnly }: HelpProps) => {
  const [lang] = useState('en')
  const { t } = useTranslation()

  const englishUrl = 'https://helpdesk.bangthetable.com/en/'
  const frenchUrl = 'https://helpdesk.bangthetable.com/fr/'
  const helpURL = lang === 'fr-CA' ? frenchUrl : englishUrl

  if (hasIconOnly) {
    return (
      <Box component="a" sx={{ display: 'contents' }} href={helpURL}>
        <HelpOutlineIcon sx={{ color: grey[700] }} />
      </Box>
    )
  }

  return (
    <ListItemButton
      component="a"
      href={helpURL}
      key="help"
      data-testid="help"
      target="_blank"
      rel="noopener"
    >
      <ListItemIcon>
        <HelpOutlineIcon />
      </ListItemIcon>
      <ListItemText primary={t('sidebar.help')} />
    </ListItemButton>
  )
}

export default Help
